import * as actionTypes from './actionTypes';
import axios from '../../utilities/interceptor';
import { getMessage } from '../../utilities/getMessage';

export const getMix=()=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_MIX_START
    });
    axios.get('/collections/last/all')
         .then(response=>dispatch({
             type:actionTypes.GET_MIX_SUCCESS,
             payload:response.data
         }))
         .catch(err=>dispatch({
             type:actionTypes.GET_MIX_FAIL,
             payload:getMessage(err)
         }))
}